import { useUpdateProfileVideo } from '@queries/profiles';
import { withAuthGate } from '@sunrise-ui/composites';
import { useSafeLocalSearchParams } from '@sunrise-ui/primitives';
import IntroPreviewView from '@templates/IntroPreviewView';
import { router } from 'expo-router';
import React from 'react';

function ProfileIntroPreviewScreen() {
  const { uri } = useSafeLocalSearchParams<{ uri: string }>();

  const { mutate: updateProfileVideo, isPending } = useUpdateProfileVideo();

  const handleSave = async () => {
    updateProfileVideo(uri, {
      onSuccess: () => {
        router.navigate('/editProfile');
      },
    });
  };

  return <IntroPreviewView handleSave={handleSave} isSaving={isPending} />;
}

export default withAuthGate(ProfileIntroPreviewScreen);
